/*@ngInject*/
const CreateQuoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createQuote = function (submissionId, productTemplateId) {
        var url = '/rest/Submission/' + submissionId + '/createQuote?productTemplateId=' + productTemplateId;

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('createQuoteRepository', CreateQuoteRepository);
